import { BuyerCustomerDTO, Permission, SalesOrderDTO } from 'core/api';
import { Preconditions } from 'core/infrastructure-next';
import { Command } from 'pos/common';
import * as SalesOrderStore from './SalesOrderStore';


declare global {
	interface CommandType {
		updateSalesOrderCustomer: (note: SalesOrderDTO) => Promise<Result<BuyerCustomerDTO>>
	}
}

Command.register('updateSalesOrderCustomer', Preconditions.ensureIsNotLite, async (order: SalesOrderDTO): Promise<Result<BuyerCustomerDTO>> => {
	return Command.execute('setOrRemoveCustomer', {
		customer: order.Customer,
		setCustomer: async (customer: BuyerCustomerDTO) => await SalesOrderStore.changeCustomer(order.Id, customer),
		hideRemoveCustomerButton: true,
		requiredPermission: Permission.SalesOrder_ChangeCustomer
	});
});
